import Core from "@/modules/core/service/Core.js";

const url = {
    create   : "/api/exchange/tge/protocol/{0}",
    assign   : "/api/exchange/tge/protocol/{0}?unit={1}",
    protocol : "/api/exchange/tge/{0}?failed=true",
    checkList: "/api/exchange/tge/{0}/{1}/checklist"
}

export default {
    findFailed () {
        return Core.method.get(url.protocol, 0);
    },

    findCheckList (protocol) {
        return Core.method.get(url.checkList, 0, protocol.id);
    },

    create (protocol) {
        return Core.method.post(url.create, null, protocol.id);
    },

    assign (protocol, unit) {
        return Core.method.post(url.assign, null, protocol.id, unit.id);
    },

    delete (protocol) {
        console.log("delete", protocol)
        return Core.method.deleteVoid(url.create, null, protocol.id);
    }
}